<template>
  <section class="tilda_bag_product">
    <div>
      <p class="new_bag_brief" v-html="shopifyData.heading" />
      <div class="tilda_product_card">
        <div v-for="(value, key) in shopifyData.product" :key="key">
          <a :href="value.productLink" class="new_product_image">
            <img
              v-lazy="value.productImage"
              :alt="value.productImage.alt || 'Product Image'"
              loading="lazy"
              aria-hidden="true"
              aria-label="Product Image"
              width=""
              height=""
            />
          </a>
          <a :href="value.productLink" class="tilda_bag_name" v-html="value.productTitle" />
          <span class="tilda_bag_price" v-html="value.productPrice" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.tilda_bag_product {
  margin: 120px 20% 0 20%;
}

.new_bag_brief {
  font-size: 13px;
  color: #000000;
  margin-bottom: 15px;
  line-height: 23px;
  font-family: 'Helvetica', sans-serif;
}

.tilda_bag_name {
  color: #4f5050;
  font-size: 11px;
  display: inline-block;
  font-family: 'Helvetica Neue', sans-serif;
}

.tilda_bag_price {
  color: #000;
  font-size: 12px;
  display: block;
  font-family: 'Helvetica', sans-serif;
}

.new_product_image {
  display: block;
}

.new_product_image img {
  width: 100%;
}

.tilda_product_card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
}

@media only screen and (max-width: 768px) {
  .tilda_product_card {
    grid-template-columns: 1fr;
  }
}
</style>
